(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if(this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["saratti-diamond-assurance"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const prepare = (root) => {
      if (root.dataset.sdaReady) return;
      root.dataset.sdaReady = 'true';
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.12 });
      observer.observe(root);
    };

    const init = (scope = document) => {
      scope.querySelectorAll('[data-sda]').forEach(prepare);
    };

    init();
    document.addEventListener('shopify:section:load', (event) => init(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["saratti-diamond-concierge-guard"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const setupGuard = (guard) => {
      if (!guard || guard.dataset.ready === 'true') return;

      const productSection = document.querySelector('.saratti-lookbook-product-section');
      const inquiry = productSection?.querySelector('.saratti-lb-inquiry');
      if (!productSection || !inquiry) return;

      const addToBagButton = Array.from(productSection.querySelectorAll('button')).find(
        (button) => button.textContent.trim().toUpperCase() === 'ADD TO BAG'
      );

      guard.dataset.ready = 'true';
      productSection.classList.add('saratti-natural-diamond-product');
      const threshold = Number(guard.dataset.thresholdCents || 1000000);
      let variants = [];

      try {
        variants = JSON.parse(guard.querySelector('[data-sdg-variants]').textContent);
      } catch (error) {
        variants = [];
      }

      const requestButton = document.createElement('button');
      requestButton.type = 'button';
      requestButton.className = 'saratti-request-purchase';
      requestButton.textContent = 'REQUEST TO PURCHASE';
      inquiry.insertAdjacentElement('beforebegin', requestButton);


      const note = document.createElement('div');
      note.className = 'saratti-lb-concierge-note';
      note.innerHTML = guard.querySelector('[data-sdg-message]').innerHTML;
      inquiry.insertAdjacentElement('afterend', note);

      const selectedVariant = () => {
        const id = productSection.querySelector('input[name="id"]')?.value;
        return variants.find((variant) => String(variant.id) === String(id)) || variants[0];
      };

      const update = () => {
        const variant = selectedVariant();
        const isHighValue = Boolean(variant && Number(variant.price) >= threshold);
        productSection.classList.toggle('saratti-lb-high-value', isHighValue);
        requestButton.hidden = !isHighValue;
        note.hidden = !isHighValue;
        if (addToBagButton) addToBagButton.hidden = isHighValue;
      };

      const inquiryModal = productSection.querySelector('[data-inquiry-modal]');
      const inquiryForm = inquiryModal?.querySelector('form');
      const inquiryHeading = inquiryModal?.querySelector('[role="dialog"] h2');
      const inquirySubmit = inquiryModal?.querySelector('button[type="submit"]');
      const requestTypeField = inquiryForm?.querySelector('input[name="contact[Request type]"]');
      const variantField = inquiryForm?.querySelector('input[name="contact[Variant]"]');
      const priceField = inquiryForm?.querySelector('input[name="contact[Displayed price]"]');
      const noteField = inquiryForm?.querySelector('textarea[name="contact[body]"]');
      const contactOverlay = document.querySelector('[data-saratti-v2-overlay]');
      const contactPanel = document.querySelector('[data-saratti-contact-panel]');
      const contactFormPanel = document.querySelector('[data-saratti-v2-panel]');
      const purchaseMessage = 'I would like to request this natural diamond engagement ring. Please contact me privately to confirm the exact GIA-certified diamond, my preferred metal and ring size, and the arrangements for secure invoicing.';

      const openContactOnly = (event) => {
        event.preventDefault();
        event.stopImmediatePropagation();

        if (inquiryModal) inquiryModal.hidden = true;
        if (contactFormPanel) {
          contactFormPanel.classList.remove('is-open');
          contactFormPanel.setAttribute('aria-hidden', 'true');
        }
        if (!contactOverlay || !contactPanel) return;

        contactOverlay.classList.add('is-open');
        contactPanel.classList.add('is-open');
        contactPanel.removeAttribute('aria-hidden');
        document.documentElement.style.overflow = '';
        document.body.style.overflow = 'hidden';
      };

      inquiry.addEventListener('click', openContactOnly, true);

      const prefillRequest = () => {
        if (!inquiryModal || !inquiryForm) return;

        const variant = selectedVariant();
        if (requestTypeField) requestTypeField.value = 'Private purchase request';
        if (variantField && variant) variantField.value = variant.title || '';
        if (priceField && variant) priceField.value = (Number(variant.price || 0) / 100).toFixed(2);
        if (inquiryHeading) inquiryHeading.textContent = 'Request to purchase';
        if (inquirySubmit) inquirySubmit.textContent = 'SUBMIT REQUEST';
        if (noteField && !noteField.value) noteField.value = purchaseMessage;

        inquiryModal.hidden = false;
        document.documentElement.style.overflow = 'hidden';
        inquiryModal.querySelector('[role="dialog"]')?.focus();
      };

      requestButton.addEventListener('click', prefillRequest);
      productSection.addEventListener('change', () => window.setTimeout(update, 0));
      document.addEventListener('variant:change', update);
      update();
    };

    const init = () => {
      document.querySelectorAll('.saratti-diamond-concierge-guard').forEach(setupGuard);
    };

    document.addEventListener('DOMContentLoaded', init);
    document.addEventListener('shopify:section:load', init);
    init();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["saratti-diamond-selection"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const prepare = (root) => {
      if (root.dataset.sdjReady) return;
      root.dataset.sdjReady = 'true';
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.16 });
      observer.observe(root);
    };

    const init = (scope = document) => {
      scope.querySelectorAll('[data-sdj]').forEach(prepare);
    };

    init();
    document.addEventListener('shopify:section:load', (event) => init(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["saratti-diamond-standard"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const prepare = (root) => {
      if (root.dataset.sdsReady) return;
      root.dataset.sdsReady = 'true';
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.18 });
      observer.observe(root);

      root.querySelectorAll('[data-sds-info]').forEach((button) => {
        button.addEventListener('click', () => {
          const dialog = document.getElementById(button.dataset.sdsInfo);
          if (dialog && typeof dialog.showModal === 'function') dialog.showModal();
        });
      });

      root.querySelectorAll('[data-sds-dialog]').forEach((dialog) => {
        const closeButton = dialog.querySelector('[data-sds-close]');
        if (closeButton) closeButton.addEventListener('click', () => dialog.close());
        dialog.addEventListener('click', (event) => {
          if (event.target === dialog) dialog.close();
        });
      });
    };

    const init = (scope = document) => {
      scope.querySelectorAll('[data-sds]').forEach(prepare);
    };

    init();
    document.addEventListener('shopify:section:load', (event) => init(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["saratti-diamond-story"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const prepare = (root) => {
      if (root.dataset.sdyReady) return;
      root.dataset.sdyReady = 'true';
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.2 });
      observer.observe(root);
    };

    const init = (scope = document) => {
      scope.querySelectorAll('[data-sdy]').forEach(prepare);
    };

    init();
    document.addEventListener('shopify:section:load', (event) => init(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["saratti-perfect-match"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const normalize = (value) => String(value || '').toLowerCase().replace(/[^a-z0-9]/g, '');

    const category = (name) => {
      const value = normalize(name);
      if (value.includes('metal') && (value.includes('color') || value.includes('colour'))) return 'metalcolor';
      if (value.includes('metal') && value.includes('type')) return 'metaltype';
      if (value.includes('ringsize') || value === 'size') return 'size';
      return value;
    };

    const selections = () => {
      const selected = {};
      document.querySelectorAll('form[action*="/cart/add"] select[name], form[action*="/cart/add"] input[name]:checked').forEach((field) => {
        const rawName = field.name.replace(/^options\[/, '').replace(/^properties\[/, '').replace(/\]$/, '');
        if (!field.value) return;
        selected[normalize(rawName)] = field.value;
        selected[category(rawName)] = field.value;
      });
      return selected;
    };

    const updateCard = (card, current) => {
      const optionsNode = card.querySelector('[data-match-options]');
      const variantsNode = card.querySelector('[data-match-variants]');
      if (!optionsNode || !variantsNode) return;

      let optionNames;
      let variants;
      try {
        optionNames = JSON.parse(optionsNode.textContent);
        variants = JSON.parse(variantsNode.textContent);
      } catch (error) {
        return;
      }

      const match = variants.find((variant) => {
        if (!variant.available) return false;
        return optionNames.every((name, index) => {
          const chosen = current[normalize(name)] || current[category(name)];
          return !chosen || normalize(variant.options[index]) === normalize(chosen);
        });
      });

      if (!match) return;
      card.querySelectorAll('[data-match-link]').forEach((link) => {
        const url = new URL(link.href, window.location.origin);
        url.searchParams.set('variant', match.id);
        link.href = url.toString();
      });
    };

    const prepare = (root) => {
      if (root.dataset.smpReady) return;
      root.dataset.smpReady = 'true';

      const refresh = () => {
        const current = selections();
        root.querySelectorAll('[data-match-card]').forEach((card) => updateCard(card, current));
      };

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.12 });

      observer.observe(root);
      document.addEventListener('change', refresh);
      refresh();
    };

    const init = (scope = document) => {
      scope.querySelectorAll('[data-smp]').forEach(prepare);
    };

    init();
    document.addEventListener('shopify:section:load', (event) => init(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
